export default "__VITE_ASSET__BcdOJ$HG__"